type AddressParts = {
  streetAddress?: string;
  cityStateZip?: string;
};

export default function formatListingAddress(address: AddressParts | undefined): string {
  if (!address?.streetAddress) return '';
  if (!address.cityStateZip) return address.streetAddress;
  return `${address.streetAddress}, ${address.cityStateZip}`;
}
